import React from 'react';
import TemplatePageLeftContent from "../template_page/template_page_left_content/template_page_left_content";
import {Page} from "../../model/page";
import Moment from "react-moment";
import {TFunction} from "i18next";
import {Translation} from "react-i18next";
import "./event_page_left_content.scss";


interface EventPageData extends Page {
    event_start_date?: string;
    event_end_date?: string;
    event_address?: string;

    event_lat?: number;
    event_lng?: number;
}

class EventPageLeftContent extends TemplatePageLeftContent<EventPageData> {

    nearHeadlines(page: EventPageData): React.ReactElement | React.ReactNodeArray | React.ReactPortal | undefined {

        let dateElement = undefined;
        if (page.event_start_date && page.event_end_date && !page.event_start_date.startsWith(page.event_end_date.substr(0, 10))) {
            dateElement =
                <Translation>
                    {(t: TFunction) =>
                        <p className="event-date">
                            <i className="fas fa-calendar-day" />
                            {t("EVENT PAGE from date")} <Moment date={page.event_start_date} format="D MMMM YYYY" className="dt-start" />&nbsp;
                            {t("EVENT PAGE time")} <Moment date={page.event_start_date} format="H.mm" utc={true} />
                            {page.event_end_date &&
                                <> {t("EVENT PAGE to date")} <Moment date={page.event_end_date} format="D MMMM YYYY" className="dt-end" /></>
                            }
                        </p>
                    }
                </Translation>;
        } else if (page.event_start_date) {
            dateElement =
                <Translation>
                    {(t: TFunction) =>
                        <p className="event-date dt-start">
                            <i className="fas fa-calendar-day" />
                            <Moment date={page.event_start_date} format="D MMMM YYYY"/>&nbsp;
                            {t("EVENT PAGE time")} <Moment date={page.event_start_date} format="H.mm" utc={true}/>
                        </p>
                    }
                </Translation>;
        }

        let placeElement = undefined;
        if (page.event_address) {
            let placeUrl = "https://www.google.com/maps/search/?api=1&query=";

            if (page.event_lat && page.event_lng) {
                placeUrl += encodeURI(page.event_lat + "," + page.event_lng);
            } else {
                placeUrl += encodeURI(page.event_address);
            }

            placeElement =
                <a href={placeUrl} className="event-place p-location" target="_blank" rel="noopener noreferrer">
                    <i className="fas fa-map-marker-alt" />
                    {page.event_address}
                </a>
        }

        return (
            <>
                {dateElement}
                {placeElement}
            </>
        );
    }

}

export default EventPageLeftContent;